import React, { useEffect, useState } from "react";
import ManageInputForm from './manageInputForm';
import {
  getFieldTypeDropdown, getInputFlowTypeDropdown, getMappedProcessTypeDropdown,
  getCreateFormDetail, postCreateFormDetail, getMappedCategory
} from "../../../../../store/actions/cms/manageRP.js";
import { clearPostCreateFormDetailSuccessResponse, clearPostCreateFormDetailMessageResponse } from '../../../../../store/slices/manageRP';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { Alert } from "@mui/material";
import { RP_FORM_MANDATORY_STATUS, RP_FORM_STATUS } from "../../../../constants/cms";

const ManageInput = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [newValues, setNewValues] = useState({})
  const queryParams = new URLSearchParams(window.location.search);
  const productId = queryParams?.get("product_id");

  const { fieldTypeData, fieldTypeLoading, inputFlowTypeData, mappedProcessTypeData,
    createFormDetailData, postCreateFormDetailData, createFormDetailLoading, mappedCategoryData, postCreateFormDetailError, postCreateFormDetailMessage, postCreateFormDetailMessageError
  } = useSelector((state) => state.manageRP_Reducer);
  const { user } = useSelector((state) => state.userData);

  const fieldTypeFields = {
    "User Input": ["input_flow_type", "display_name", "place_holder_text", "error_message", "min_val", "max_val", "weight", "mapped_process_type", "mandatory", "status"],
    "Application Number": ["display_name", "place_holder_text", "error_message", "weight", "mandatory", "status"],
    "Category Dropdown": ["display_name", "place_holder_text", "mapped_category", "error_message", "weight", "mapped_process_type", "mandatory", "status"],
    "Select List Dropdown": ["display_name", "place_holder_text", "list_option_data", "weight", "mapped_process_type", "error_message", "mandatory", "status"],
    "Radio Button": ["display_name", "list_option_data", "weight", "mapped_process_type", "mandatory", "status"],
    "Date of Birth": ["display_name", "place_holder_text", "weight", "error_message", "mandatory", "status"]
};

  useEffect(() => {
    if (productId) {
      dispatch(getFieldTypeDropdown({ field_name: 'rp_field_type' }));
      dispatch(getInputFlowTypeDropdown({ field_name: 'input_flow_type' }));
      dispatch(getMappedProcessTypeDropdown({ field_name: 'mapped_process_type', product_id: productId }));
      dispatch(getMappedCategory({ field_name: 'mapped_category' }));
    }
  }, [productId]);

  useEffect(() => {
    if (id) {
      dispatch(getCreateFormDetail({ id: id }))
    }
  }, [id])

  const getMatchingValue = (value, statusList) => (
    statusList?.find((statusItem) => statusItem.value === (value ? 1 : 0))
  );


  // Initial values for the form
  const initialValues = {
    field_type: null,
    input_flow_type: null,
    display_name: '',
    place_holder_text: '',
    error_message: '',
    min_val: '',
    max_val: '',
    weight: '',
    mapped_process_type: null,
    mandatory: null,
    status: null,
    list_option_data: '',
    mapped_category: null,
  }
  // Setting up Form state in Edit Case
  useEffect(() => {
    if (createFormDetailData) {
      let modifiedValues = {};
      createFormDetailData.forEach((item) => {
        modifiedValues.field_type = item.field_type;
        modifiedValues.input_flow_type = item.input_flow_type;
        modifiedValues.display_name = item.display_name;
        modifiedValues.place_holder_text = item.place_holder_text;
        modifiedValues.error_message = item.error_message;
        modifiedValues.min_val = item.min_val;
        modifiedValues.max_val = item.max_val;
        modifiedValues.weight = item.weight;
        modifiedValues.list_option_data = item.list_option_data;
        modifiedValues.mapped_process_type = item.mapped_process_type;
        modifiedValues.mapped_category = item.mapped_category;
        modifiedValues.mandatory = getMatchingValue(item.mandatory, RP_FORM_MANDATORY_STATUS),
        modifiedValues.status = getMatchingValue(item.status, RP_FORM_STATUS)
      });
      setNewValues(modifiedValues);
    }
  }, [createFormDetailData]);

  const submit = (values) => {
    const params = {
        id,
        product_id: productId,
        field_type: values?.field_type?.id,
        created_by: user?.data?.id,
        updated_by: user?.data?.id,
    };

    const selectedFields = fieldTypeFields[values?.field_type?.value] || [];

    selectedFields?.forEach(field => {
      if (typeof values?.[field] === 'object') {
          params[field] = values?.[field]?.id || values?.[field]?.value;
      } else {
          if (typeof values?.[field] === 'string') {
              params[field] = values?.[field]?.trim();
          } else {
              params[field] = values?.[field];
          }
      }
  });
  
    dispatch(postCreateFormDetail(params));
};

  useEffect(() => {
    if (postCreateFormDetailMessage) {
      setTimeout(() => {
        dispatch(clearPostCreateFormDetailSuccessResponse());
      }, 2000);
    }
  }, [postCreateFormDetailMessage]);

  return (
    <div>
      <div className={"notification_popup"}>
        {postCreateFormDetailMessage && (
          <Alert
            severity={
              postCreateFormDetailError || postCreateFormDetailMessageError
                ? `error`
                : `success`
            }
          >
            {" "}
            {postCreateFormDetailMessage}{" "}
          </Alert>
        )}

      </div>
      {id && newValues && <ManageInputForm
        initialValues={newValues}
        fieldTypeData={fieldTypeData}
        inputFlowTypeData={inputFlowTypeData}
        mappedProcessTypeData={mappedProcessTypeData}
        mappedCategoryData={mappedCategoryData}
        submit={(values) => submit(values)}
        id={id}
        postCreateFormDetailError={postCreateFormDetailError}
        clearPostCreateFormDetailMessageResponse={clearPostCreateFormDetailMessageResponse}
        dispatch={dispatch}
        fieldTypeFields={fieldTypeFields}
      />}
      {!id && <ManageInputForm
        initialValues={initialValues}
        fieldTypeData={fieldTypeData}
        inputFlowTypeData={inputFlowTypeData}
        mappedProcessTypeData={mappedProcessTypeData}
        mappedCategoryData={mappedCategoryData}
        submit={(values) => submit(values)}
        postCreateFormDetailError={postCreateFormDetailError}
        clearPostCreateFormDetailMessageResponse={clearPostCreateFormDetailMessageResponse}
        dispatch={dispatch}
        fieldTypeFields={fieldTypeFields}
      />}
    </div>
  )
}

export default ManageInput
